export const COLORS = {
  orange: '#ea5e01',
  green: '#05c305',
  lightOrange: '#f7ceb2',
  lightGrey: '#e1e1e1',
  lighterGrey: '#ebebeb',
  greyTwo: '#616060',
  greyThree: '#403f3f',
  greyFour: '#f7f7f7',
  white: '#ffffff',
  grey: '#a3a2a2',
  black: '#000000',
  blackTwo: '#181817',
  red: '#db0000',
  blue: '#e2edff',
  saveBlue: '#2561eb'
}
export default COLORS;



// WEBPACK FOOTER //
// ./src/components/colors.js